import { useSupportSheet } from "../../components/SupportSheet";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { BodyCopy } from "../../components/BodyCopy";
import {
  AuraLayout,
  Button,
  Layout,
  PageTitle,
} from "lola-framework-ui-test";
import { FlowHeroMark } from "../../components/FlowHeroMark";
import { DiscardCardIcon, SupportStrokeIcon } from "../../assets/icons";
import { useStore } from "../../store/globalState";
import { ScrollFadeIndicator } from "../../components/ScrollFadeIndicator";
import { Navbar } from "../../components/Navbar";

const REQUESTER_NAME_PLACEHOLDER = "Sofia Ospina";

/**
 * Gallery discard confirmation. The live flow only shows this button when
 * the partner set an http(s) return URL, and it leaves the widget. It does
 * not go back to the payable intention.
 */
export const IntentionDiscardPage = memo(() => {
  const { t } = useTranslation("fund-request");
  const { theme } = useStore();
  const { openSupport, supportSheet } = useSupportSheet("fund-request");

  const colorConfig = theme.errorView;
  const {
    backgroundBtn,
    textColorBtn,
    title,
    bodyCopy,
    iconColors,
    backgroundIcon,
  } = colorConfig;

  return (
    <>
    <AuraLayout colorConfig={colorConfig} className="need-help-header flow-landing-page">
      <Layout.Header>
        <Navbar
          title={t("common.needHelp")}
          align="right"
          noBackButton
          color={title}
          onIconClick={openSupport}
          icon={
            <SupportStrokeIcon
              size={35}
              colors={[backgroundIcon, backgroundIcon]}
              glyphColor={iconColors[0]}
            />
          }
        />
      </Layout.Header>
      <Layout.Content className="landing-section flow-hero-section flow-hero-section--with-header">
        <ScrollFadeIndicator color={colorConfig.bodyCopy} />
        <section className="flow-hero">
          <FlowHeroMark backgroundIcon={backgroundIcon}>
            <DiscardCardIcon size={60} colors={iconColors} />
          </FlowHeroMark>
          <section className="landing-container">
            <PageTitle
              highlight={t("fundRequest.discardScreen.highlight")}
              highlightColor={title}
              secudnary={t("fundRequest.discardScreen.secondary")}
              secudnaryColor={title}
            />
            <BodyCopy textColor={bodyCopy}>
              {t("fundRequest.discardScreen.body", {
                name: REQUESTER_NAME_PLACEHOLDER,
              })}
            </BodyCopy>
          </section>
        </section>
      </Layout.Content>
      <Layout.Footer>
        <section className="footer-section">
          <Button
            size="large"
            background={backgroundBtn}
            color={textColorBtn}
            onClick={() => undefined}
          >
            {t("fundRequest.discardScreen.cta")}
          </Button>
        </section>
      </Layout.Footer>
    </AuraLayout>
      {supportSheet}
    </>
  );
});
